import { useEffect, useState } from 'react';
import { Box, Text } from '@nimbus-ds/components';
import {
  OnboardingTask,
  OnboardingTaskUpdateRequestDto,
} from '@tiendanube/common';
import { SHOW_PROMOTE_TASKS_MOBILE_TAG } from 'App/featuresFlags';
import { useHasTags } from 'App/hooks';
import { useAppDispatch } from 'App/store';
import {
  trackingPromoteConnectClick,
  trackingPromoteSkipClick,
} from 'App/tracking';
import { useIsMobileDevice } from 'domains/Auth/hooks';
import { useTranslationDashboard } from 'domains/Dashboard/hooks';
import { updateOnboardingTaskStatusAction } from 'domains/Dashboard/slices/onBoardingSlice';
import OnboardingPromoteTasks from '../OnboardingPromoteTasks';

interface PromoteListProps {
  tasks: OnboardingTask[];
}

function PromoteList({ tasks }: PromoteListProps) {
  const t = useTranslationDashboard();
  const dispatch = useAppDispatch();
  const [visibleTasks, setVisibleTasks] = useState(tasks);
  const isMobileDevice = useIsMobileDevice();
  const [hasShowPromoteTasksTag] = useHasTags(SHOW_PROMOTE_TASKS_MOBILE_TAG);

  const handleConnect = (task: OnboardingTask) => {
    trackingPromoteConnectClick(task.name);
  };

  const handleSkip = async (task: OnboardingTask) => {
    trackingPromoteSkipClick(task.name);
    const payload: OnboardingTaskUpdateRequestDto = {
      task: task.name,
      status: 'skipped',
    };
    setVisibleTasks((tasks) => tasks.filter((t) => t.name !== task.name));
    await dispatch(updateOnboardingTaskStatusAction(payload));
  };

  useEffect(() => {
    setVisibleTasks(tasks);
  }, [tasks]);

  if (isMobileDevice && !hasShowPromoteTasksTag) return null;

  if (!visibleTasks || visibleTasks.length === 0) return null;

  return (
    <Box display="flex" flexDirection="column" gap="4">
      <Text fontSize="highlight" color="neutral-textHigh">
        {t('promote.title')}
      </Text>
      <OnboardingPromoteTasks
        tasks={visibleTasks}
        onAction={handleConnect}
        onSkip={handleSkip}
        type="promote"
      />
    </Box>
  );
}

export default PromoteList;
